import { Injectable, Inject } from '@angular/core';
import {Log} from '../../../models/log';

@Injectable({
    providedIn: 'root'
})
export class LogsService {

    public logs: Log[] = [];
    private logsPersistance = false;

    constructor(
    ) {}

    info(name: string, data: any = null) {
        // @ts-ignore
        console.info(name, data);
        if ( this.logsPersistance ) {
            this.logs.push({ name, data, date: new Date().toISOString() });
        }
    }

    enableLogsPersistance() {
        this.logsPersistance = true;
    }

}
